import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReportsFilter from '../../../reportsFilter';

const ShopFilter = ({ updateFilter, filters, title, allChecked, className }) => (
  <div className={classNames('c-select-group u-visible-for-extralarge-and-up c-select--border', className)}>
    <div
      className="c-label u-ml--"
    >
      Filter by shop
    </div>
    <ReportsFilter
      title={title}
      filters={filters}
      updateStatusViewed={updateFilter}
      showSelectAll
      allChecked={allChecked}
    />
  </div>
);
ShopFilter.propTypes = {
  updateFilter: PropTypes.func.isRequired,
  filters: PropTypes.arrayOf(PropTypes.object).isRequired,
  title: PropTypes.string.isRequired,
  allChecked: PropTypes.bool.isRequired,
  className: PropTypes.string,
};

ShopFilter.defaultProps = {
  className: null,
};

export default ShopFilter;
